import { Card, Layout } from '@loadsmart/miranda-react'

import { type SpotQuote } from '../domain/SpotQuote'
import { ShipperHeader } from './ShipperHeader'

export type SpotQuoteHeaderProps = {
  readonly spotQuote: SpotQuote
}

export function SpotQuoteHeader({ spotQuote }: SpotQuoteHeaderProps) {
  const {
    shipper,
    quote: { managedBy },
  } = spotQuote

  return (
    <Card>
      <Card.Body>
        <Layout.Group align="center" justify="space-between">
          <ShipperHeader shipper={shipper} managedBy={managedBy} />
        </Layout.Group>
      </Card.Body>
    </Card>
  )
}
